// src/components/layout/EmbedLayout.tsx
import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

export function EmbedLayout() {
  return (
    <div className="min-h-screen bg-white">
      <main>
        <Outlet />
      </main>

      <Toaster
        position="bottom-right"
        gutter={8}
        toastOptions={{
          duration: 4000,
          style: {
            fontFamily: 'Outfit, sans-serif',
            fontSize: '13px',
            borderRadius: '10px',
            boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
          },
          success: {
            iconTheme: { primary: '#10b981', secondary: '#fff' },
          },
          error: {
            iconTheme: { primary: '#ef4444', secondary: '#fff' },
          },
        }}
      />
    </div>
  );
}
